import * as Yup from 'yup';

export default Yup.object().shape({
  drivers: Yup.array().min(1, 'Co najmniej jeden kierowca musi być wybrany'),
  content: Yup.string().required('Treść nie moża być pusta'),
});
